<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addMaintRecord.title')" backdrop shadow
            :visible="allowAddRecord" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('maintenanceShared.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addMaintRecord.recordLabel')" class="text-left mb-0" v-if="showRecordField">
                            <b-form-input v-model="recordPayload.record_no" type="text" :placeholder="$t('addMaintRecord.recordPlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.record_no" class="field-error">
                                {{ errors.record_no[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('addMaintRecord.recordLabel')" class="text-left mb-0" v-else>
                            <b-form-input v-model="lastRecord" disabled type="text" :placeholder="$t('addMaintRecord.recordPlaceholder')" class="unit"
                                required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('addMaintRecord.statusLabel') }}</label>
                            <b-form-select class="f-12" v-model="recordPayload.status" :options="statusOptions" />
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left mt-3">
                            <label for="modal-add-record-date-datepicker" class="state">{{ $t('addMaintRecord.dateLabel') }}</label>
                            <date-picker v-model="recordPayload.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="recordPayload.date = ''" :placeholder="$t('maintenanceShared.selectDate')" class="date-picker-custom"
                                :teleport="'body'"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('addMaintRecord.unitLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="recordPayload.unit_no" :options="nameOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchAssets"
                                @option:selected="unitSelected">
                                <span slot="no-options">
                                    {{ $t('addMaintRecord.searchUnit') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.unit_no" class="field-error">
                                {{ errors.unit_no[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left ">
                            <b-form-group :label="$t('addMaintRecord.odometerLabel')" class="text-left mb-0">
                                <b-form-input type="text" v-mask="numberMask" :placeholder="$t('addMaintRecord.odometerPlaceholder')" required
                                    v-model="recordPayload.odometer"></b-form-input>
                                <p v-if="errors && errors.odometer" class="field-error">
                                    {{ errors.odometer[0] }}
                                </p>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left ">
                            <b-form-group :label="$t('addMaintRecord.amountLabel')" class="text-left mb-0">
                                <b-form-input type="text" class="f-12" v-mask="amountMask" @blur="amountHandler"
                                    :placeholder="$t('addMaintRecord.amountPlaceholder')" required v-model="recordPayload.amount"></b-form-input>
                                <p v-if="errors && errors.amount" class="field-error">
                                    {{ errors.amount[0] }}
                                </p>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <hr class="my-4" />
                        <h3 class="f-18 font-weight-bold text-left">{{ $t('addMaintRecord.vendorSection') }}</h3>
                        <div class="d-flex align-items-center mt-4">
                                <v-select class="bg_white w-100 f-12" v-model="recordPayload.vendor" :options="vendorOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchVendors"
                                @option:selected="unitSelected">
                                <span slot="no-options">
                                    {{ $t('addMaintRecord.searchVendor') }}
                                </span>
                            </v-select>
                            <b-button @click="$bvModal.show('modal-vendor')" class="h-40px w-40px mw-40px ml-2"
                                variant="primary"><svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 6.5H1H6Z" fill="#2D69F6" />
                                    <path d="M6 11.5V6.5M6 6.5V1.5M6 6.5H11M6 6.5H1" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                            </b-button>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <hr class="my-4" />
                    </b-col>
                    <b-col md="12">
                        <h3 class="f-18 font-weight-bold text-left">{{ $t('addMaintRecord.typesSection') }}</h3>
                        <v-select class="f-12 mt-4" :options="allTypes" multiple :reduce="(option) => option.id"
                            v-model="recordPayload.types" />
                    </b-col>
                    <b-col md="12">
                        <hr class="my-4" />
                    </b-col>
                    <b-col md="12">
                        <div class="text-left">
                            <h3 class="f-18 font-weight-bold text-left">{{ $t('addMaintRecord.descriptionSection') }}</h3>
                            <b-form-textarea id="textarea" class="f-12 mt-4" :placeholder="$t('maintenanceShared.descriptionPlaceholder')" rows="5"
                                v-model="recordPayload.description"></b-form-textarea>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <hr class="my-4" />
                    </b-col>
                    <b-col md="12" class="mb-7rem">
                        <h3 class="f-18 font-weight-bold text-left">{{ $t('addMaintRecord.addDocumentSection') }}</h3>
                        <div class="upload-btn-wrapper mt-3">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!fileName" class="foo">
                                {{ $t('addMaintRecord.dropDocument') }}
                            </button>
                            <div v-else>
                            <button  class="foo">{{ fileName }}</button>
                            <p class="text-danger-color cursor-pointer f-12 remove-file-link z-100" @click="removeFile()">{{ $t('addMaintRecord.delete') }}</p>
                            </div>
                            <input ref="docFile" class="right-0" type="file" name="docFile" v-on:change="handleFileUpload"
                                accept=".pdf, .png, .jpg, .jpeg" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                        <!-- <div v-else>
              <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                <div v-else>
                  <div id="panzoom-element" ref="panzoomElement">
                    <img :src="media" class="w-100 h-100 img-section" />
                  </div>
                  <div class="d-flex align-items-center justify-content-center zoom-section">
                    <b-icon @click="zoom(1)" icon="zoom-in" style="fill:white; cursor: pointer;"></b-icon>
                    <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out" style="fill:white;cursor: pointer;"></b-icon>
                  </div>
                </div>
              </div>
            </div> -->
                    </b-col>
                </b-row>
                <!-- <b-row class="px-4 mb-7rem">
                    <h3 class="f-18 font-weight-bold col-12 text-left mb-0">Schedule</h3>
                    <b-col cols="12">
                        <div class="text-left">
                            <label class="state mt-4">Add Schedule</label>
                            <b-form-checkbox class="pl-3-5" name="check-button" switch v-model="addSchedule"
                                size="lg"></b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col cols="12" v-if="addSchedule">
                        <b-row>
                            <b-col sm="12">
                                <div class="text-left my-3">
                                    <label for="due-date-picker" class="state">Date</label>
                                    <b-form-datepicker id="due-date-picker" class="" v-model="schedulePayload.due_date"
                                        reset-button></b-form-datepicker>
                                    <p v-if="errors && errors.schedule_due_date" class="field-error">
                                        {{ errors.schedule_due_date[0] }}
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <div class="text-left">
                                    <label class="state">Description</label>
                                    <b-form-textarea id="textarea" class="f-14" placeholder="Enter Description" rows="5"
                                        v-model="schedulePayload.description"></b-form-textarea>
                                    <p v-if="errors && errors.schedule_description" class="field-error">
                                        {{ errors.schedule_description[0] }}
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row> -->
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('maintenanceShared.cancel') }}</b-button>
                    <b-button class="mx-0 h-40px px-2 mr-3" @click="addMaintenance(true)"
                        variant="outline-primary">{{ $t('maintenanceShared.saveAndOpen') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px" @click="addMaintenance()" variant="primary">{{ $t('maintenanceShared.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
        <AddandUpdateVendor v-if="allowAddRecord" :allowAddData="true" :editVendor="false" @updateVendorList="getAllVendors"
            :states="states" />
        <!-- <EditRecord v-if="recordID" :recordID="recordID" @resetMaintenance="recordID = ''"
            @recordUpdated="$emit('recordAdded', true)" /> -->
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { mapActions, mapGetters } from "vuex"
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Panzoom from '@panzoom/panzoom'
import AddandUpdateVendor from "./AddandUpdateVendor.vue";
const numberMask = createNumberMask({
    prefix: "",
    allowDecimal: true,
    includeThousandsSeparator: true,
});
const amountMask = createNumberMask({
    prefix: "",
    allowDecimal: true,
    includeThousandsSeparator: true,
});
export default {
    name: "addRecord",
    components: { vSelect, DatePicker, AddandUpdateVendor },
    props: {
        unitNo: {
            type: Object,
            default: null
        },
        allowAddRecord: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            numberMask,
            states: [],
            amountMask,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            lastRecord: null,
            showRecordField: false,
            recordID: null,
            nameOptions: [],
            vendorOptions: [],
            recordDocument: null,
            panzoom: null,
            fileName: "",
            media: "",
            mediaType: "",
            recordPayload: {
                record_no: "",
                date: new Date(),
                unit_no: null,
                description: null,
                amount: null,
                odometer: null,
                status: "New",
                vendor: null,
                types: []
            },
            editFlag: false,
            errors: {}
        }
    },
    computed: {
        ...mapGetters(["currentMaintenance", "userCompany", "vendors", "types", "allCountries"]),
        statusOptions() {
            return [
                { value: 'New', text: this.$t('maintenanceShared.statusNew') },
                { value: 'Open', text: this.$t('maintenanceShared.statusOpen') },
                { value: 'Closed', text: this.$t('maintenanceShared.statusClosed') },
                { value: 'Urgent', text: this.$t('maintenanceShared.statusUrgent') },
            ];
        },
        allVendors() {
            return this.vendors.map((item) => {
                return {
                    id: item.id,
                    label: item.name,
                }
            })
        },
        allTypes() {
            return this.types.map((item) => {
                return {
                    id: item.id,
                    label: item.name,
                }
            })
        },
    },
    watch: {
        unitNo() {
            if (this.unitNo) {
                this.recordPayload.unit_no = this.unitNo.id
                this.nameOptions = [this.unitNo]
                this.recordPayload.description = this.description,
                    this.recordPayload.odometer = this.unitNo.odometer
            }
        },
        async allowAddRecord() {
            if (this.allowAddRecord) {
                this.setLoader(true)
                const lastItemRecord = await this.getLastRecord({
                    company_id: this.userCompany,
                    query: `model_name=maintenance`
                })
                if (lastItemRecord) this.lastRecord = lastItemRecord + 1;
                else this.showRecordField = true
                await this.getCountries()
                this.setLoader(false)
            }
        }
    },
    methods: {
        ...mapActions(["getAllCountries", "getFilteredEquipments", "postMaintenance", "patchMaintenance", "patchMaintenanceSchedule", "setNotification", "postMaintenanceSchedule", "setLoader", "getLastRecord", "getAllVendors", "sendMaintenanceDocument"]),
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        handleFileUpload() {
            this.recordDocument = this.$refs.docFile.files[0];
            this.fileName = this.recordDocument.name;
            this.media = URL.createObjectURL(this.recordDocument);
            if (this.$refs.docFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        removeFile(){
            this.recordDocument = null
            this.fileName = ""
            this.media = ""
            this.mediaType = ""  
            this.$refs.docFile.value = null;   
        },
        async getCountries() {
            await this.getAllCountries();
            this.countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates();
        },
        getStates() {
            this.states = this.allCountries[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
        },
        unitSelected(data) {
            this.recordPayload.odometer = data.odometer.toLocaleString()
        },
        amountHandler(event) {
            const value = event.target.value;
            if (value && !value.includes('.')) {
                event.target.value = `${value}.00`;
            }
        },
        resetPopup() {
            this.recordPayload = {
                record_no: "",
                date: new Date(),
                unit_no: null,
                description: null,
                amount: null,
                odometer: null,
                status: "New",
                vendor: null,
                types: []
            }
            this.recordDocument = null
            this.panzoom = null,
                this.fileName = ""
            this.media = ""
            this.mediaType = ""
            this.errors = {}
            this.$emit('close');
        },
        checkNullValues(payload, type) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (
                    !value &&
                    key !== "document" &&
                    key.toLowerCase() !== "odometer" &&
                    key !== "amount" && key !== 'record_no' && key !== 'description' && key !== 'vendor' && key !== 'types'
                ) {
                    nullKeys.push(key);
                }
            }
            if (
                type === "maintenance" &&
                this.showRecordField &&
                !this.recordPayload.record_no
            ) {
                nullKeys.push("record_no");
            }
            return nullKeys;
        },
        async addMaintenance(openRecord = false) {
            let record
            try {
                const nullKeys = this.checkNullValues(this.recordPayload, "maintenance");
                // const unit_no = this.recordPayload.unit_no;
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    const payload = {
                        unit_no: this.recordPayload.unit_no,
                        vendor: this.recordPayload.vendor,
                        types: this.recordPayload.types,
                        date: moment(this.recordPayload.date).format("YYYY-MM-DD"),
                        amount: this.recordPayload.amount
                            ? parseFloat(this.recordPayload.amount.replace(/,/g, '')).toFixed(2)
                            : 0,
                        description: this.recordPayload.description,
                        status: this.recordPayload.status,
                        odometer: this.recordPayload.odometer
                            ? this.recordPayload.odometer.toString().replace(/,/g, "")
                            : ""
                    };

                    if (this.showRecordField) {
                        payload.record_no = this.recordPayload.record_no;
                    }

                    record = await this.postMaintenance(payload);
                    if (this.recordDocument) {
                        let formData = new FormData();
                        formData.append(
                            "date",
                            moment().format("YYYY-MM-DD")
                        );
                        formData.append("description", "Document");
                        formData.append(
                            "document",
                            new File(
                                [this.recordDocument],
                                this.recordPayload.record_no + "_" +
                                this.nameOptions.filter(
                                    (item) => item.id === this.recordPayload.unit_no
                                )[0].label +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.recordDocument["type"].split("/").pop(),
                                { type: this.recordDocument["type"] }
                            )
                        );
                        formData.append("company_id", this.userCompany);
                        await this.sendMaintenanceDocument({ formData, id: record.id });
                    }

                } else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('maintenanceShared.fieldRequired')];
                    });
                    throw error;
                }
                this.editFlag = false;
                this.fileName = null;
                await this.setNotification({
                    msg: this.$t('addMaintRecord.maintenanceAdded'),
                    type: "success",
                    color: "green",
                });
                this.recordPayload = {
                    date: new Date(),
                    unit_no: null,
                    description: null,
                    amount: null,
                    odometer: null,
                    status: "New",
                    vendor: null,
                    types: []
                };
                this.nameOptions = []
                this.vendorOptions = []
                if (openRecord) this.$emit("recordAdded", record.id)
                else this.$emit("recordAdded", null)
                this.setLoader(false)
                return record
            } catch (error) {
                if (typeof error === "object") {
                    if (error.data) {
                        await this.setNotification({
                            msg: `${Object.keys(error?.data)[0].charAt(0).toUpperCase() + Object.keys(error?.data)[0].slice(1)}: ${error?.data[Object.keys(error?.data)[0]]
                                }`,
                            type: "error",
                            color: "red",
                        });
                    }
                    this.errors = error;
                    this.setLoader(false)
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
                equipmentRecords.map((item) => {
                    options.push({
                        id: `${item.id}`,
                        label: item.unit_no,
                        type: "equipment",
                        odometer: item.current_odometer ? item.current_odometer : 0
                    });
                });
                this.nameOptions = [...new Map(options.map(item => [item['id'], item])).values()]

            }
        },
        async searchVendors(searchText) {
            if (searchText) {
                let options = []
                let url = `page=1&page_size=25&search=${searchText}`
                const vendorRecords = await this.getAllVendors(url);
                vendorRecords.records.map((item) => {
                    options.push({
                        id: `${item.id}`,
                        label: item.name,
                    });
                });
                this.vendorOptions = [...new Map(options.map(item => [item['id'], item])).values()]

            }
        }
    },
}
</script>